// extracted by mini-css-extract-plugin
export default {"wrapper":"_52f7ccf3"};